import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = { class: "py-1 px-2 text-red text-base font-bold rounded-lg" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "p-1 text-pink text-base font-bold" }, ":", -1)
const _hoisted_4 = { class: "py-1 px-2 text-red text-base font-bold rounded-lg" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "p-1 text-pink text-base font-bold" }, ":", -1)
const _hoisted_6 = { class: "py-1 px-2 text-red text-base font-bold rounded-lg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.time.hours), 1),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.time.minutes), 1),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.time.seconds), 1)
  ]))
}